import { Link } from "react-router-dom";
import { Activity, Phone, Mail, MapPin } from "lucide-react";
import { SITE, telLink, mailLink } from "../data/siteConfig";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Diagnostic Tests", to: "/tests" },
  { label: "Health Packages", to: "/health-packages" },
  { label: "Home Collection", to: "/home-sample-collection" },
  { label: "Book a Test", to: "/book-a-test" },
  { label: "Contact", to: "/contact" },
  { label: "FAQ", to: "/faq" },
];

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Medical Disclaimer", to: "/medical-disclaimer" },
];

const Footer = () => (
  <footer className="bg-[#0B3056] text-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#1E88E5] text-white">
            <Activity size={22} aria-hidden="true" />
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-base font-extrabold">{SITE.name}</span>
            <span className="block text-xs text-blue-200">{SITE.tagline}</span>
          </span>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-blue-100">
          Convenient diagnostic sample collection services for patients in {SITE.city}, Madhya Pradesh.
        </p>
        <p className="mt-4 flex items-start gap-2 text-sm text-blue-100">
          <MapPin size={16} className="mt-0.5 shrink-0" aria-hidden="true" />
          {SITE.city}, {SITE.region}
        </p>
      </div>

      <nav aria-label="Footer quick links">
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-blue-200">Quick Links</h3>
        <ul className="mt-4 space-y-2.5">
          {quickLinks.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-blue-100 transition-colors hover:text-white"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-blue-200">Contact</h3>
        <ul className="mt-4 space-y-3 text-sm text-blue-100">
          <li>
            <a href={telLink} data-testid="footer-phone-link" className="flex items-center gap-2 transition-colors hover:text-white">
              <Phone size={16} aria-hidden="true" /> {SITE.phone}
            </a>
          </li>
          <li>
            <a href={mailLink} data-testid="footer-email-link" className="flex items-center gap-2 break-all transition-colors hover:text-white">
              <Mail size={16} className="shrink-0" aria-hidden="true" /> {SITE.email}
            </a>
          </li>
        </ul>
      </div>

      <nav aria-label="Legal links">
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-blue-200">Legal</h3>
        <ul className="mt-4 space-y-2.5">
          {legalLinks.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-legal-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-sm text-blue-100 transition-colors hover:text-white"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <p className="text-xs leading-relaxed text-blue-200">
          This website provides information about diagnostic sample collection services. It is not intended to provide
          medical diagnosis or treatment. Please consult a qualified healthcare professional for medical advice. This is
          the website of an independent collection center in Bhopal and not the corporate website of Dr Lal PathLabs Ltd.
        </p>
        <p className="mt-3 text-xs text-blue-300">
          © {new Date().getFullYear()} {SITE.fullName}, {SITE.city}. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
